import { Checkbox as BaseCheckbox } from "native-base";
const Checkbox = (props) => {
    const { label, value, onChange } = props;
    return (<BaseCheckbox value={value} onChange={onChange} size="sm" colorScheme="green">
      {label}
    </BaseCheckbox>);
};
export default Checkbox;
